import { render, staticRenderFns } from "./OtherBenefitsDetails.vue?vue&type=template&id=51f5ca21&scoped=true"
import script from "./OtherBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./OtherBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./OtherBenefitsDetails.vue?vue&type=style&index=0&id=51f5ca21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5ca21",
  null
  
)

export default component.exports